<template>
  <div no-body class="salary-slip monthly-container">
    <!-- 公司信息头部 -->
    <div class="company-header">
      <div class="logo">
        <img src="@/assets/images/logo/salary_logo.png" alt="WF Logo" />
      </div>
      <div class="company-info">
        <h1>{{ companyInfo.company_name || "永發設計工程有限公司-會計部" }}</h1>
        <p v-if="companyInfo.address">地址： {{ companyInfo.address }}</p>
        <p v-if="companyInfo.phone">電話： {{ companyInfo.phone }}</p>
        <p v-if="companyInfo.website">網址： {{ companyInfo.website }}</p>
        <p v-if="companyInfo.email">電郵： {{ companyInfo.email }}</p>
        <!-- 載入中或錯誤時顯示預設資訊 -->
        <template v-if="!companyInfo.address && !isLoadingCompanyInfo">
          <p>地址： 新界元朗鳳翔路 45-67 號金馬大廈 29 樓地下</p>
          <p>電話： 24798967</p>
          <p>網址： http://wingfatdesign.com</p>
          <p>電郵： sales@wingfatdesign.com</p>
        </template>
      </div>
    </div>

    <h2 class="slip-title">工資單</h2>
    <!-- {{ pdfData }} -->
    <!-- 员工基本信息表格 -->
    <div class="employee-info">
      <table class="info-table">
        <tr>
          <td>員工証明：</td>
          <td>{{ pdfData.name_cn }}</td>
          <td>計薪方式：</td>
          <td>月薪</td>
        </tr>
        <tr>
          <td>系統帳號：</td>
          <td>{{ pdfData.name }}</td>
          <td>支付帳號名稱：</td>
          <td>{{ pdfData.bank_account_name }}</td>
        </tr>
        <tr>
          <td>員工編號：</td>
          <td>{{ pdfData.user_number }}</td>
          <td>支付帳號號碼：</td>
          <td>{{ pdfData.bank_account }}</td>
        </tr>
        <tr>
          <td>職位：</td>
          <td>{{ pdfData.position }}</td>
          <td>銀行識別編號：</td>
          <td v-if="pdfData.bank_id">
            {{
              bankOptions &&
              bankOptions.length > 0 &&
              bankOptions.find((bank) => bank.id === pdfData.bank_id).name
            }}
          </td>
        </tr>
        <tr>
          <td>部門：</td>
          <td>{{ pdfData.department }}</td>
          <td>入職日期：</td>
          <td>{{ pdfData.join_date }}</td>
        </tr>
        <tr>
          <td>支付方式：</td>
          <td>
            {{ getSalaryReceiveMethodName() }}
            <span v-if="isChecquePayment() && currentMonth.check_number">
              <br />支票號碼：{{ currentMonth.check_number }}
            </span>
          </td>
          <td>支付日期：</td>
          <td>{{ (currentMonth.payment_date && currentMonth.payment_date.split("T")[0]) || "不適用" }}</td>
        </tr>
        <!-- ... 其他员工信息行 ... -->
      </table>
    </div>

    <!-- 工资明细表格 -->
    <div class="salary-details">
      <div class="d-flex justify-content-between">
        <h3>工資(最近一個月) - {{ currentMonth.year }}/{{ currentMonth.month >= 10 ? currentMonth.month : '0' + currentMonth.month }}</h3>
        <b>HKD</b>
      </div>
      <table class="salary-table">
        <tr>
          <td>固定工資</td>
          <td class="amount">{{ currentMonth.total_salary }}</td>
        </tr>
        <tr>
          <td>逾時工作/遲到/早退</td>
          <td class="amount">
            {{
              currentMonth.ot_amount ? currentMonth.ot_amount : "不適用"
            }}
          </td>
        </tr>
        <tr>
          <td>佣金或花紅</td>
          <td class="amount">
            {{ currentMonth.commission ? currentMonth.commission : "不適用" }}
          </td>
        </tr>
        <tr>
          <td>其他津貼  {{ currentMonth.allowance_remark ? ` - ${currentMonth.allowance_remark}` : "" }}</td>
          <td class="amount">
            {{ currentMonth.allowance ? currentMonth.allowance : "不適用" }}
          </td>
        </tr>
        <tr>
          <td>強積金（僱主部份）</td>
          <td class="amount">
            {{
              currentMonth.mpf_employer ? currentMonth.mpf_employer : "不適用"
            }}
          </td>
        </tr>
        <tr>
          <td>強積金（僱員部份）</td>
          <td class="amount">
            {{
              currentMonth.mpf_employee ? currentMonth.mpf_employee : "不適用"
            }}
          </td>
        </tr>
        <tr>
          <td>預支總金額</td>
          <td class="amount">
            {{
              currentMonth.prepayment_amount ? currentMonth.prepayment_amount : "不適用"
            }}
          </td>
        </tr>
        <!-- ... 其他工资项目 ... -->
      </table>
      <div class="salary-total">
        <div class="d-flex justify-content-end">
          <b>應發工資：</b>
          <span class="amount">{{
            currentMonth.gross_salary ? currentMonth.gross_salary : 0
          }}</span>
        </div>
        <div class="d-flex justify-content-end">
          <b>實發工資：</b>
          <span class="amount">{{
            currentMonth.actual_salary ? currentMonth.actual_salary : 0
          }}</span>
        </div>
      </div>
    </div>

    <!-- 历史工资记录表格 -->
    <div class="salary-history mt-1">
      <div class="d-flex align-items-end justify-content-between">
        <b class="">過往 11 個月工資</b>
        <div class="signature"></div>
      </div>
      <table class="history-table">
        <thead>
          <tr>
            <th>過往月份</th>
            <th>固定工資</th>
            <th>逾時工作</th>
            <th>佣金/花紅</th>
            <th>其他津貼</th>
            <th style="font-size:12px">強積金(僱主)</th>
            <th style="font-size:12px">強積金(僱員)</th>
            <th>預支金額</th>
            <th>實發工資</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in pdfData.salary_records.filter((item) => item.is_current === false)" :key="item.month">
            <td>{{ item.year }}/{{item.month >=10 ? item.month : '0' + item.month }}</td>
            <td>{{ item.total_salary ? item.total_salary : `0.00` }}</td>
            <td>{{ item.ot_amount ? item.ot_amount : `0.00` }}</td>
            <td>{{ item.commission ? item.commission : `0.00` }}</td>
            <td>
              {{ item.allowance ? item.allowance : `0.00` }}
              <!-- {{ item.allowance_remark ? ` - ${item.allowance_remark}` : "" }} -->
            </td>
            <td>{{ item.mpf_employer ? item.mpf_employer : `0.00` }}</td>
            <td>{{ item.mpf_employee ? item.mpf_employee : `0.00` }}</td>
            <td>{{ item.prepayment_amount ? item.prepayment_amount : `0.00` }}</td>
            <td>{{ item.actual_salary ? item.actual_salary : `0.00` }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer-note">
      本糧單由系統自動生成，資方可按需要在空白位置蓋章以作証明。
    </div>
  </div>
</template>
<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";

import { mapFields } from "vuex-map-fields";
import { formatMoney } from "@/libs/helper.js";
import NoticeToCustomers from "@/views/invoice/invoices-preview/NoticeToCustomers.vue";
import { ref, watch } from "@vue/composition-api";
import axiosIns from "@/libs/axios";

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
      companyInfo: {
        company_name: "",
        address: "",
        phone: "",
        website: "",
        email: "",
      },
      isLoadingCompanyInfo: false,
    };
  },
  methods: {
    formatMoney,
    async fetchCompanyInfo() {
      this.isLoadingCompanyInfo = true;
      try {
        const response = await axiosIns.get(
          "templates/1"
        );
        const template = response.data.template;
        this.companyInfo = {
          company_name: "永發設計工程有限公司-會計部",
          address: template.address || "",
          phone: template.phone || "",
          website: template.website || "",
          email: template.email || "",
        };
      } catch (error) {
        console.error("獲取公司資訊失敗:", error);
        // 保持預設值，不做任何改變
      } finally {
        this.isLoadingCompanyInfo = false;
      }
    },
    changeDate(dateToChange) {
      var newDate = new Date(dateToChange);
      newDate.toLocaleString("default", { month: "long" });
      return (
        newDate.getDate() +
        " " +
        this.month[newDate.getMonth()] +
        " " +
        newDate.getFullYear()
      );
    },
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
    getProject(id) {
      return (
        this.projectOptions &&
        this.projectOptions.length > 0 &&
        this.projectOptions.find((project) => project.id === id)
      );
    },
  
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === "string") {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === "object" && str.content) {
        return typeof str.content === "string"
          ? str.content.replace(/\n/g, "<br>")
          : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === "object" && str.title) {
        return typeof str.title === "string"
          ? str.title.replace(/\n/g, "<br>")
          : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === "number" || typeof str === "boolean") {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str
          .map((item) =>
            typeof item === "string"
              ? item
              : typeof item === "object" && item.content
              ? item.content
              : String(item)
          )
          .join("<br>");
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== "[object Object]" ? stringValue : "";
      } catch (error) {
        console.warn("changeNextLine: 無法處理的資料類型", str);
        return "";
      }
    },
    splitIntoPages() {
      const pageHeight = 528; // 假设页面高度为500px
      let currentPage = [];
      let currentHeight = 0;
      if (this.pdfData.cost_items && this.pdfData.cost_items.length > 0) {
        const counted_array = this.pdfData.cost_items.map((item, index) => {
          return {
            ...item,
            count: index + 1,
          };
        });

        this.pages = counted_array.reduce((acc, item, index) => {
          const itemHeight = this.calculateItemHeight(item.item_description);
          // + remarkHeight
          if (currentHeight + itemHeight > pageHeight) {
            acc.push(currentPage);
            currentPage = [];
            currentHeight = 0;
          }
          currentPage.push(item);
          currentHeight = Math.round((currentHeight + itemHeight) * 100) / 100;

          return acc;
        }, []);

        if (currentPage.length > 0) {
          this.pages.push(currentPage);
        }

        if (this.pdfData.remark) {
          const remarkHeight = this.calculateItemHeight(this.pdfData.remark);
          const remark_item = {
            is_remark: true,
            id: null,
            item_description: this.pdfData.remark,
            quantity: null,
            unit_price: null,
            amount: null,
          };
          if (remarkHeight + currentHeight > pageHeight) {
            this.pages.push([remark_item]);
          } else {
            this.pages[this.pages.length - 1].push(remark_item);
          }
        }
      } else {
        this.pages = [{ empty: true }];
      }
    },

    calculateItemHeight(item) {
      const baseHeight = 24; // 基础高度
      if (!item) {
        return baseHeight;
      }

      // 创建临时元素来计算实际高度
      const tempDiv = document.createElement("div");
      tempDiv.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: 229px; // 设置与实际显示区域相同的宽度
        font-size: 14px; // 确保字体大小与实际显示一致
        line-height: 1.5; // 设置行高
        white-space: pre-wrap; // 保留换行符并自动换行
      `;

      // 将HTML内容设置到临时元素
      tempDiv.innerHTML = item;
      document.body.appendChild(tempDiv);

      // 获取实际高度
      const actualHeight = tempDiv.offsetHeight;

      // 清理临时元素
      document.body.removeChild(tempDiv);

      // 返回计算后的高度，确保至少有基础高度
      return Math.max(baseHeight, Math.round(actualHeight * 100) / 100);
    },
    //   getTotalAmount() {
    //     var totalAmount = 0;
    //     if (this.pdfData.cost_items) {
    //       this.pdfData.cost_items.forEach((item) => {
    //         totalAmount += item.amount;
    //       });
    //     }
    //     return totalAmount;
    //   },
    getSalaryReceiveMethodName() {
      // if (!this.currentMonth.salary_receive_method) {
      //   return this.pdfData.payment_method || '未指定';
      // }
      console.log("this.currentMonth", this.currentMonth);
      return (
        (this.currentMonth &&
          this.currentMonth.payment_method &&
          this.currentMonth.payment_method.name) ||
        ""
      );
    },
    isChecquePayment() {
      // 檢查 salary_receive_method_id 是否為 1（支票）
      if (this.currentMonth.salary_receive_method_id === 1) {
        return true;
      }
      // 檢查 salary_receive_method 是否標記為支票
      if (
        this.currentMonth.salary_receive_method &&
        this.currentMonth.salary_receive_method.is_cheque
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    NoticeToCustomers,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    bankOptions: {
      type: Array,
      required: true,
    },
    remarkOptions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    "pdfData.cost_items": {
      handler() {
        this.splitIntoPages();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    // 載入公司資訊
    this.fetchCompanyInfo();

    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
    ...mapFields(["controlValue"]),
    currentMonth() {
      const defaultData = {
        month: this.pdfData.start_date,
        year: this.pdfData.year,
        base_salary: 0,
        total_salary: '0.00',
        gross_salary: '0.00',
        actual_salary: '0.00',
        ot_amount: 0,
        commission: 0,
        allowance: 0,
        allowance_remark: '',
        mpf_employer: 0,
        mpf_employee: 0,
        prepayment_amount: '0.00',
        payment_date: null,
        check_number: '',
      };

      if (!this.pdfData.salary_records || this.pdfData.salary_records.length === 0) {
        return defaultData;
      }

      // 檢查是否為日薪資料結構（包含 summaries）
      const firstRecord = this.pdfData.salary_records[0];

      if (firstRecord.summaries && firstRecord.summaries.length > 0) {
        // 日薪邏輯：匯總所有 summaries 的資料
        const summaries = firstRecord.summaries;

        const aggregatedData = {
          year: firstRecord.year,
          month: firstRecord.month,
          total_salary: '0.00',
          gross_salary: '0.00',
          actual_salary: '0.00',
          ot_amount: '0.00',
          commission: '0.00',
          allowance: '0.00',
          allowance_remark: '',
          mpf_employer: '0.00',
          mpf_employee: '0.00',
          prepayment_amount: '0.00',
          payment_date: null,
          check_number: '',
        };

        // 匯總所有項目的金額
        let totalSalary = 0;
        let grossSalary = 0;
        let actualSalary = 0;
        let otAmount = 0;
        let commission = 0;
        let allowance = 0;
        let mpfEmployer = 0;
        let mpfEmployee = 0;
        let prepaymentAmount = 0;
        let allowanceRemarks = [];

        summaries.forEach(summary => {
          totalSalary += parseFloat(summary.total_salary || 0);
          grossSalary += parseFloat(summary.gross_salary || 0);
          actualSalary += parseFloat(summary.actual_salary || 0);
          otAmount += parseFloat(summary.ot_amount || 0);
          commission += parseFloat(summary.commission || 0);
          allowance += parseFloat(summary.allowance || 0);
          mpfEmployer += parseFloat(summary.mpf_employer || 0);
          mpfEmployee += parseFloat(summary.mpf_employee || 0);
          prepaymentAmount += parseFloat(summary.prepayment_amount || 0);

          // 收集津貼備註
          if (summary.allowance_remark && summary.allowance_remark.trim()) {
            allowanceRemarks.push(summary.allowance_remark.trim());
          }

          // 使用第一個有效的支付日期和支票號碼
          if (!aggregatedData.payment_date && summary.payment_date) {
            aggregatedData.payment_date = summary.payment_date;
          }
          if (!aggregatedData.check_number && summary.check_number) {
            aggregatedData.check_number = summary.check_number;
          }
        });

        // 格式化匯總結果
        aggregatedData.total_salary = totalSalary.toFixed(2);
        aggregatedData.gross_salary = grossSalary.toFixed(2);
        aggregatedData.actual_salary = actualSalary.toFixed(2);
        aggregatedData.ot_amount = otAmount.toFixed(2);
        aggregatedData.commission = commission.toFixed(2);
        aggregatedData.allowance = allowance.toFixed(2);
        aggregatedData.mpf_employer = mpfEmployer.toFixed(2);
        aggregatedData.mpf_employee = mpfEmployee.toFixed(2);
        aggregatedData.prepayment_amount = prepaymentAmount.toFixed(2);
        aggregatedData.allowance_remark = allowanceRemarks.join(', ');

        return aggregatedData;
      } else {
        // 月薪或項目薪資邏輯：直接使用第一筆記錄
        return firstRecord;
      }
    },
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);
      console.log("template", template);
      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);
      if (template) {
        info.value.website = template.website;
        info.value.address = template.address;
        info.value.phone = template.phone;
        info.value.fax = template.fax;
        info.value.email = template.email;
        info.value.company_info = template.company_info;
        info.value.bank_info = template.bank_info;
        info.value.logo_url = template.logo_url;
        info.value.stamp_url = stamp ? stamp.image_url || '' : '';
      }
    };
    const getRemark = (id) => {
      let remark =
        props.remarkOptions && props.remarkOptions.find((ele) => ele.id == id);
      return remark && remark.content;
    };

    var init = true;

    watch(
      () => props.pdfData,
      (newVal, oldVal) => {
        if (newVal && newVal.template_id && init) {
          getInfo(newVal.template_id, newVal.stamp_id);
          init = false;
        }
      }
    );

    return {
      info,
      getInfo,
      getRemark,
    };
  },
};
</script>

<style lang="scss">
.salary-slip.monthly-container {
  padding: 40px;
  max-width: 100%;
  margin: 0 auto;
  height: 1100px;

  background: #fff;
  * {
    font-family: 新細明體;
  }

  .company-header {
    display: flex;
    // align-items: center;

    .logo {
      width: 120px;
      margin-right: 20px;
      margin-top: -10px;

      img {
        width: 100%;
      }
    }

    .company-info {
      h1 {
        font-size: 18px;
        margin-bottom: 10px;
      }
      p {
        margin: 5px 20px;
        color: #666;
        font-size: 12px;
      }
    }
  }

  .slip-title {
    text-align: right;
    font-size: 24px;
    margin: 0px 0 0;
    border-bottom: 1px solid #000;
  }
  .salary-details {
    h3 {
      font-size: 16px;
    }
    table {
      td {
        padding: 4px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .salary-total {
    .amount {
      width: 100px;
    }
  }
  .info-table,
  .salary-table,
  .history-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0px 0 15px;
    border-bottom: 1px solid #000;

    td,
    th {
      padding: 3px !important;
      // border: 1px solid #ddd;
    }
  }

  .history-table {
    th,
    td {
      // background-color: #f5f5f5;
      font-weight: bold;
      border: 1px solid #000;
      width: 72px;
      max-width: 72px;
      min-width: 72px;
      }
    
  }

  .amount {
    text-align: right;
  }
  .footer-note {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: #666;
  }
  .signature {
    width: 200px;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    height: 3px;
    margin-bottom: 4px;
    position: relative;
    &:before {
      content: "簽名:";
      font-size: 12px;
      color: #666;
      position: absolute;
      top: -20px;
      left: -30px;
    }
  }
}
</style>
